import { styled } from '@mui/material/styles';

export const StyledEducatorsHomeBanner = styled('div')`
  /* The headline is baked into the artwork, so the design pins the banner at
     160px tall at every desktop width and lets the image cover the box. As the
     content column narrows the scene crops in from both edges — the student and
     the notebook panel go first — instead of the text shrinking with it. */
  width: 100%;
  height: 160px;
  border-radius: 16px;
  overflow: hidden;
  box-sizing: border-box;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
